import { render } from "./blogheader.vue?vue&type=template&id=11aa4244"
import script from "./blogheader.vue?vue&type=script&lang=js"
export * from "./blogheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__